// import { firebase, zipCentral, zipEast } from './api/firebase'
import { firebase } from './api/firebase'
import { firebaseAction } from 'vuexfire'

const db = firebase.database()
// const zipDB2 = zipCentral.database()
// const zipDB3 = zipEast.database()
// const zipDBToUse = [zipDB2, zipDB3]

const environment = require('@/environments/production')

export const inventoryExport = {
  state: {
    exports: [],
    rMin: 1,
    rMax: 2 // this will need to grow as we add more projects to handle zip requests...
  },
  getters: {
    availableExports: state => {
      return state.exports.slice().reverse()
    }
  },
  // if you get any errors like:
  // [vuex] Do not mutate vuex store state outside mutation handlers.
  // read this again:
  // https://stackoverflow.com/questions/38365075/vuex-vuejs-do-not-mutate-vuex-store-state-outside-mutation-handlers

  mutations: {
  },
  actions: {
    getExports: firebaseAction(context => {
      let ref = db.ref('collage-downloads').child(context.rootState.user.groupId)
      console.log('export ref: ', ref.toString())
      context.bindFirebaseRef('exports', ref)
    }),
    deleteExport: (context, payload) => {
      let item = JSON.parse(payload.item)
      // before we delete the database record we need to delete the store file first
      // console.log('key: ', payload.key)
      // console.log('item:', JSON.stringify(item))
      return firebase.storage().ref(item.metadata.name).delete()
        .then(() => {
          return db.ref('collage-downloads').child(context.rootState.user.groupId).child(payload.key).remove()
        })
    },
    submitExportRequest: firebaseAction((context, payload) => {
      const random = 0 // Math.floor(Math.random() * (2 - 1 + 1)) // Math.floor(Math.random() * (2 - 1 + 1) + 1)
      console.log('random: ', random)
      return db.ref(environment.schema.collageExportRequest).child(context.rootState.user.groupId).set({
        error: null,
        status: 'submitting...',
        'request-type': {
          all: payload
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/inventoryExport.js